import { render } from "./DraftPage.vue?vue&type=template&id=48b5242b&ts=true"
import script from "./DraftPage.vue?vue&type=script&lang=ts"
export * from "./DraftPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__